export enum LocalStorageKeys {
  ACCESS_TOKEN = 'accessToken',
}

export interface CommonFields {
  countryCode: string;
  hasRecordingConsent: boolean;
  id: string;
  isAIPowerUser: boolean;
  isAllowedToUseAI: boolean;
  isQA: boolean;
  name: string;
  provider: string;
  role: string;
  email: string;
}

export interface RoleFlags {
  isAdmin: boolean;
  isParent: boolean;
  isQA: boolean;
  isSalesUser: boolean;
  isSchoolAdmin: boolean;
  isStudent: boolean;
  isTeacher: boolean;
  isPortalUser: boolean;
}

export type RoleFlagOptions = Partial<RoleFlags>;

export const PORTAL_ROLES = ['Admin', 'SalesUser', 'SchoolAdmin'];

export interface UserInfo extends CommonFields, RoleFlags {}

export type Point = {
  x: number;
  y: number;
};

export type Points = Array<Point>;

export type Lines = Array<{
  tool: string;
  points: Points;
}>;

export enum CdnObjectType {
  Image = 'image',
  Audio = 'audio',
}

export enum SymbolType {
  Sound = 'sound',
  Word = 'word',
  Sentence = 'sentence',
}

export interface CdnObjectContext {
  word?: string;
}

export const VOWELS = ['a', 'e', 'i', 'o', 'u'];
export const CONSONANTS = [
  'b',
  'c',
  'd',
  'f',
  'g',
  'h',
  'j',
  'k',
  'l',
  'm',
  'n',
  'p',
  'q',
  'r',
  's',
  't',
  'v',
  'w',
  'x',
  'y',
  'z',
];
export const ALL_LETTERS = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
];

export const SUFFIX_S = 's';
export const SUFFIX_ES = 'es';
export const SUFFIX_ER = 'er';
export const SUFFIX_EST = 'est';
export const SUFFIX_ED = 'ed';
export const SUFFIX_ING = 'ing';
export const PREFIX_MIS = 'mis';
export const PREFIX_DIS = 'dis';
export const PREFIX_UN = 'un';
export const PREFIX_RE = 're';
export const PREFIX_DE = 'de';
export const PREFIX_PRE = 'pre';

export const SUFFIXES = [
  SUFFIX_S,
  SUFFIX_ES,
  SUFFIX_ER,
  SUFFIX_EST,
  SUFFIX_ED,
  SUFFIX_ING,
];

export const PREFIXES = [
  PREFIX_MIS,
  PREFIX_DIS,
  PREFIX_UN,
  PREFIX_RE,
  PREFIX_DE,
  PREFIX_PRE,
];

export const SUFFIX_GROUPS = [
  [SUFFIX_S, SUFFIX_ES],
  [SUFFIX_ER, SUFFIX_EST],
  [SUFFIX_ED, SUFFIX_ING],
];

export const LETTER_SETS = [
  ['s', 'a', 't', 'p', 'i', 'n'],
  ['c', 'e', 'h', 'r', 'm', 'd'],
  ['g', 'o', 'u', 'l', 'f', 'b'],
];
